import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space, borderRadius } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { style } from '@vanilla-extract/css';

export const applyPointsContainer = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: space.s12,
  backgroundColor: themeVars.container.secondary.background.idle,
  borderRadius: borderRadius.r8,
  gap: space.s12,
});

export const applyPointsInfo = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s2,
});

export const applyPointsLabel = style({
  ...typography.labelSm,
  color: themeVars.container.foreground.secondary,
});

export const applyPointsValue = style({
  ...typography.titleSm,
  color: themeVars.container.foreground.primary,
});

export const applyPointsApplied = style({
  ...typography.labelMd,
  color: themeVars.container.foreground.success,
  flexShrink: 0,
});
